import { FC, useMemo } from "react";
import Stack from "@mui/material/Stack";
import { Button, Tooltip } from "@mui/material";
import { filterTreeFiltersAreInvalid } from "@/components/pages/common/filters-tree/utils/helpers/filterTreeFiltersAreInvalid";
import { FilterTreeNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";
import { BillingExplorerFilterTreeAddToDimensionList } from "@/components/pages/resource-explorer/components/app-bar/components/resource-explorer-toolbar/components/add-filter-tree-to-dimension/BillingExplorerFilterTreeAddToDimensionList";

interface ResourceExplorerFilterTreeActionsProps {
  onCancel(): void;
  onApply(): void;
  filterTree?: FilterTreeNodeWithId;
}

export const ResourceExplorerFilterTreeActions: FC<
  ResourceExplorerFilterTreeActionsProps
> = ({ filterTree, onCancel, onApply }) => {
  const invalid = useMemo(() => {
    return filterTree && filterTreeFiltersAreInvalid(filterTree, true);
  }, [filterTree]);

  return (
    <Stack
      mt={2}
      pt={1}
      pb={2}
      direction="row"
      spacing={2}
      justifyContent="space-between"
      alignItems="center"
      bottom={0}
      bgcolor="white"
      position="sticky"
      zIndex="appBar"
    >
      <BillingExplorerFilterTreeAddToDimensionList filterTree={filterTree} />

      <Stack direction="row" alignItems="center">
        <Button color="tertiary" onClick={onCancel}>
          Cancel
        </Button>

        <Tooltip
          arrow
          placement="top"
          title={
            invalid
              ? "To apply filters, make sure all values are selected."
              : ""
          }
        >
          <span>
            <Button
              color="primary"
              variant="contained"
              onClick={onApply}
              disabled={invalid}
            >
              Apply Filters
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </Stack>
  );
};
